<template>
  <router-view></router-view>
</template>

<script>
export default {
	name: 'Coleções',
	title: 'Coleção - Coleções'
}
</script>

<style scoped>
</style>
